import { render, staticRenderFns } from "./allerganApp.vue?vue&type=template&id=100cbd23"
import script from "./allerganApp.vue?vue&type=script&lang=js"
export * from "./allerganApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports